import api from "../api/axios";

export const CIVILSTATUS_QUERY_KEY = ["civil-status"];
export const VIEW_CIVILSTATUS_QUERY_KEY = ["view-civil-status"];

export interface CreateCivilStatusPayload {
  code: string;
  name: string;
  status: number;
  created_by?: number;
  updated_by?: number;
}

export interface UpdateCivilStatusPaylod {
  code: string;
  name: string;
  updated_by?: number;
}

export const civilstatusService = {
  getAllViewCivilStatus: async () => {
    const response = await api.get(`api/view-civil-status`);
    return response.data;
  },

  getViewCivilStatusByID: async (code: string) => {
    const response = await api.get(`api/view-civil-status/${code}`);
    return response.data;
  },

  createCivilStatus: async (payload: CreateCivilStatusPayload) => {
    const response = await api.post(`api/civil-status`, payload);
    return response.data;
  },

  updateCivilStatus: async (code: string, payload: UpdateCivilStatusPaylod) => {
    const response = await api.put(`api/civil-status/${code}`, payload);
    return response.data;
  },

  toggleStatus: async (id: string) => {
    const response = await api.put(`api/civil-status/${id}/toggle-status`);
    return response.data;
  },
};
